var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"strengthBox"},[_c('div',{staticClass:"strength"},[_c('span',{class:'red'}),_c('span',{class:'orange'}),_c('span',{class:'green'}),_c('p',{staticClass:"displayText",class:_vm.strengthText === 'weak'
					? 'redTxt'
					: _vm.strengthText === 'mid'
					? 'orangeTxt'
					: 'greenTxt'},[_vm._v(" 弱 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }